import styled from '@emotion/styled';

const RatingContainer = styled.span`
  display: inline-flex;
  column-gap: 1px;
`;

export { RatingContainer };
